<template>
  <!--- <PuSkeletonTheme :duration="0.1" color="rgb(22, 23, 25)" highlight="rgb(94 94 94 / 73%)"> --->
<PuSkeletonTheme :duration="0.1" color="rgb(5, 0, 53, 1)" highlight="rgb(27 25 53)">
  <div class="flex items-center">
    <vs-avatar :src="simulation.thumbnail" class="flex-shrink-0 mr-2" size="30px" @click="$router.push(url)" />
    <router-link :to="url" @click.stop.prevent class="text-inherit hover:text-primary" v-if="simulation.name">{{ this.simulation.name }}</router-link>
    <PuSkeleton v-else class="" style="width: 250px; height: 100%"></PuSkeleton>
  </div>
  </PuSkeletonTheme>
</template>

<script>
export default {
  data () {
    return {
      simulation: {
        full_name: null,
        thumbnail: 'https://cdn.discordapp.com/attachments/746242308084858900/848762736255172679/default-placeholder.png'
      }
    }
  },
  computed: {
    url () {
      return `/a/simulations/${this.params.value}`
    },
    authorId () {
      return this.params.data.author
    }
  },
  created () {


    this.$httpc.get(`simulations/${this.params.value}`, {
      ttl: 45
    })
      .then(response => {

        if (response.data.data) {
          this.simulation = response.data.data

          if (response.data.data.thumbnail !== null) {
            this.simulation.thumbnail = response.data.data.thumbnail
          } else {
            this.simulation.thumbnail = 'https://cdn.discordapp.com/attachments/746242308084858900/848762736255172679/default-placeholder.png'
          }

        }

      })
      .catch(exception => {

        let error = 'An unknown error occurred loading customer details'
        if (exception.response) {
          error = exception.response.data.error.description
        }

        return this.$vs.notify({
          title: 'Failed to author',
          text: error,
          color: 'danger',
          position: 'top-right'
        })
      })

  }
}

</script>
